import { render } from "./page-about.vue?vue&type=template&id=d799a4e4&ts=true"
import script from "./page-about.vue?vue&type=script&lang=ts"
export * from "./page-about.vue?vue&type=script&lang=ts"

import "./page-about.vue?vue&type=style&index=0&id=d799a4e4&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__